import axios from 'axios';

let cache = null;
let inflight = null;

/**
 * Fetch marketing media map from GET /site-media.
 * Returns { [key]: { url, alt } }.
 */
export async function fetchSiteMedia() {
  if (cache) return cache;
  if (inflight) return inflight;

  inflight = axios
    .get('/site-media')
    .then((res) => {
      cache = res.data?.assets || {};
      return cache;
    })
    .catch((err) => {
      console.error('Failed to load site media:', err);
      cache = {};
      return cache;
    })
    .finally(() => {
      inflight = null;
    });

  return inflight;
}

/** URL for a site-media key (Cloudinary via API). */
export function mediaUrl(assets, key) {
  return assets?.[key]?.url || '';
}
